var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReceiveTailoredQuotes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 76,
    viewBox: "0 0 61 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 1.25,
    width: 58.5,
    height: 73.5,
    rx: 3.75,
    stroke: "#ED553B",
    strokeWidth: 2.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 19.5,
    width: 27,
    height: 1,
    rx: 0.5,
    stroke: "#ED553B"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 31.5,
    width: 43,
    height: 1,
    rx: 0.5,
    stroke: "#ED553B"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 36.5,
    width: 43,
    height: 1,
    rx: 0.5,
    stroke: "#ED553B"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 41.5,
    width: 43,
    height: 1,
    rx: 0.5,
    stroke: "#ED553B"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 46.5,
    width: 43,
    height: 1,
    rx: 0.5,
    stroke: "#ED553B"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 51.5,
    width: 37,
    height: 1,
    rx: 0.5,
    stroke: "#ED553B"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 61.5,
    width: 14,
    height: 1,
    rx: 0.5,
    stroke: "#ED553B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M10.2474 6.156C11.5434 6.768 12.3714 7.992 12.3714 9.684C12.3714 12.132 10.6074 13.716 8.26741 13.716C5.89141 13.716 4.16341 12.132 4.16341 9.684C4.16341 8.676 4.30741 7.884 5.35141 5.58L7.65541 0.287998H11.9394L10.2474 6.156ZM19.6794 6.156C20.9754 6.768 21.8034 7.992 21.8034 9.684C21.8034 12.132 20.0394 13.716 17.6994 13.716C15.3234 13.716 13.5954 12.132 13.5954 9.684C13.5954 8.676 13.7394 7.884 14.7834 5.58L17.0874 0.287998H21.3714L19.6794 6.156Z",
    fill: "#ED553B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceiveTailoredQuotes);
export default __webpack_public_path__ + "static/media/receive-tailored-quotes.27beb551dfa66055632560689714cad3.svg";
export { ForwardRef as ReactComponent };